// extracted by mini-css-extract-plugin
export default {"tabsList":"TabBar_tabsList__6fAy+","tabItem":"TabBar_tabItem__b6AgM","tabActive":"TabBar_tabActive__5g9iX","tabHovered":"TabBar_tabHovered__YyKoM"};